import { isDevOrTest } from "~www/utils/is-dev-or-test";

type BlockDebugDevProps = {
  blockType: string;
  /**
   * When true, renders unconditionally regardless of NODE_ENV.
   * Pass isDraftMode from a parent server component to make debug messages
   * visible in Sanity Visual Editing / draft mode preview.
   */
  forceVisible?: boolean;
  message?: string;
};

export function BlockDebugDev({
  blockType,
  forceVisible = false,
  message = "Component not found for block type",
}: BlockDebugDevProps) {
  const showDebug = forceVisible || isDevOrTest();

  if (!showDebug) {
    return null;
  }

  return (
    <div className="flex items-center justify-center rounded-lg bg-muted p-8 text-center text-muted-foreground">
      {blockType}: {message}
    </div>
  );
}
